import React from "react";
import { connect } from "react-redux";
import { formatSubs } from "../utils/array";
import _ from "lodash";
import {
  startGettingSubscriptions,
  startGettingPlans,
  startBuyingPlan
} from "../actions/plans";
import Plan from "./Plan";
import { Row, Col } from "antd";
import * as R from "ramda";
import PlanData from "./PlanData";
import "../styles/components/plans-popup.scss";

class PlansPopUp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      plan: props.activePlans[0].subscription_plan,
      monthly: true // Always monthly - yearly plans disabled
    };
  }
  componentDidMount() {
    this.props.startGettingPlans();
    this.props.startGettingSubscriptions();
  }

  onClick = data => {
    this.setState(() => ({
      plan: data
    }));
  };

  // Yearly plans disabled - keeping monthly only
  // isMonthlyOrYearly = e => {
  //   this.setState(prevState => ({
  //     monthly: !prevState.monthly
  //   }));
  // };

  render() {
    const getFeatures = R.split("|");
    const objectizeFeatures = feature => ({ value: feature, isActive: true });
    const formatFeatures = R.map(objectizeFeatures);

    const checkActivation = id => {
      let isActive = false;
      R.forEach(plan => {
        if (plan.is_active && plan.subscription_plan.id === id) {
          isActive = true;
        }
      }, this.props.activePlans);
      return isActive;
    };

    const sortByLevel = R.sortBy(R.prop("level"));
    return (
      <div className="plans-popup-body">
        <div className="card-inner">
          {/* Yearly plan toggle disabled */}
          {/* <span class="switcher switcher-1">
            <input
              type="checkbox"
              id="switcher-1"
              onChange={this.isMonthlyOrYearly}
              checked={this.state.monthly}
            />
            <label for="switcher-1"></label>
          </span> */}
          {!R.isEmpty(this.props.plans) ? (
            <Row
              gutter={32}
              className="frame"
              type="flex"
              justify="space-around"
            >
              {sortByLevel(this.props.plans).map(el => (
                <Col xl={6} lg={6} md={12} sm={12} className="plan-wrapper">
                  <Plan
                    img={el.image_url}
                    price={el.default_cost} // Always use monthly pricing
                    name={el.name}
                    buy={this.props.startBuyingPlan}
                    key={el.name}
                    close={this.props.closePopUp}
                    plan={formatFeatures(getFeatures(el.description))}
                    budget={this.props.budget}
                    active={checkActivation(el.id)}
                    level={el.level}
                    salable={this.props.subscriptionLevel < el.level}
                    select={this.onClick}
                    rawData={el}
                    selected={
                      this.state.plan ? this.state.plan.id === el.id : false
                    }
                    yearly={false} // Always monthly
                  />
                </Col>
              ))}
              <Col span={24} className="datas-wrapper">
                <PlanData
                  data={this.state.plan}
                  maxData={this.props.plans.filter(el => el.level === 3)[0]}
                  yearly={false} // Always monthly
                />
                {/* <ul className="info">
                  <li>
                    You can use all your notification budget in a lesser
                    duration.
                  </li>
                  <li>
                    After finishing your notification budget. Notifications will
                    be payed from your credit if you have any.
                  </li>
                </ul> */}
              </Col>
            </Row>
          ) : (
            undefined
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  plans: state.plans.plans || [],
  subscriptions: formatSubs(state.plans.subscriptions, "name") || [],
  activePlans: state.plans.subscriptions || [],
  subscriptionLevel:
    _.max(formatSubs(state.plans.subscriptions, "level")) || [],
  budget: state.auth.charged_budget
});

const mapDispatchToProps = dispatch => ({
  startGettingSubscriptions: () => dispatch(startGettingSubscriptions()),
  startGettingPlans: () => dispatch(startGettingPlans()),
  startBuyingPlan: (plan_name, period) =>
    dispatch(startBuyingPlan(plan_name, period))
});

export default connect(mapStateToProps, mapDispatchToProps)(PlansPopUp);
